module.exports = __webpack_public_path__ + "img/f-4-1.59502c34.png";